/**
 * Definições de dicas proativas exibidas na primeira visita a cada seção.
 * Cada dica é contextual à seção e aparece com animação suave.
 */

export interface ProactiveTipDefinition {
  id: string;
  section: string; // e.g. 'banking', 'tokenization', 'compliance'
  icon: string; // Lucide icon name e.g. 'Landmark', 'Coins'
  title: string;
  description: string;
}

export const proactiveTipDefinitions: ProactiveTipDefinition[] = [
  {
    id: 'tip-banking',
    section: 'banking',
    icon: 'Landmark',
    title: 'Bem-vindo ao Banking',
    description:
      'Aqui você gerencia suas contas, realiza transferências, PIX e pagamentos. Explore o extrato para acompanhar todas as movimentações.',
  },
  {
    id: 'tip-tokenization',
    section: 'tokenization',
    icon: 'Coins',
    title: 'Tokenização de Ativos',
    description:
      'Crie e gerencie tokens representando ativos reais. Acompanhe o ciclo completo: originação, compliance, deploy e negociação.',
  },
  {
    id: 'tip-compliance',
    section: 'compliance',
    icon: 'ShieldCheck',
    title: 'Compliance e Regulatório',
    description:
      'Gerencie regras PLD/FT, comunicações COAF e fila de aprovação de ativos. Mantenha seu tenant em conformidade com as normas do BACEN.',
  },
  {
    id: 'tip-credit',
    section: 'credit',
    icon: 'BadgeDollarSign',
    title: 'Motor de Crédito',
    description:
      'Configure políticas de crédito, simule empréstimos e acompanhe a carteira de crédito do tenant com análise de score e inadimplência.',
  },
  {
    id: 'tip-cards',
    section: 'cards',
    icon: 'CreditCard',
    title: 'Cartões',
    description:
      'Emita cartões virtuais e físicos para seus clientes. Configure limites, bandeiras e acompanhe faturas e transações.',
  },
  {
    id: 'tip-investments',
    section: 'investments',
    icon: 'TrendingUp',
    title: 'Investimentos',
    description:
      'Explore o marketplace de investimentos com produtos de renda fixa e variável. Acompanhe rentabilidade e gerencie seu portfólio.',
  },
  {
    id: 'tip-crypto',
    section: 'crypto',
    icon: 'Bitcoin',
    title: 'Criptomoedas e DeFi',
    description:
      'Acesse carteiras crypto, marketplace P2P, staking, yield farming e swap avançado. Tudo integrado à sua conta bancária.',
  },
  {
    id: 'tip-contracts',
    section: 'contracts',
    icon: 'FileSignature',
    title: 'Contratos Digitais',
    description:
      'Crie, envie e assine contratos digitalmente com validade jurídica. Use templates com campos dinâmicos para agilizar o processo.',
  },
  {
    id: 'tip-kyc',
    section: 'kyc',
    icon: 'UserCheck',
    title: 'KYC e Verificação',
    description:
      'Gerencie o processo de verificação de identidade dos clientes. Acompanhe a fila de análise, documentos e status de aprovação.',
  },
  {
    id: 'tip-settings',
    section: 'settings',
    icon: 'Settings',
    title: 'Configurações',
    description:
      'Personalize sua experiência: segurança, notificações, autenticação em dois fatores e preferências da conta.',
  },
];
